export default __webpack_public_path__ + "static/patient-guide--cervical-cancer-f5bd49df42953739d8a86770a3bcfc3b.png";